"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DNGridWarehouse = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var collectionsRef_1 = require("common/db/collectionsRef");
var budgetLinesList_1 = require("common/global/budgetLinesList");
var currenciesList_1 = require("common/global/currenciesList");
var donorsList_1 = require("common/global/donorsList");
var projectsList_1 = require("common/global/projectsList");
var unitsList_1 = require("common/global/unitsList");
var usersList_1 = require("common/global/usersList");
var warehousesList_1 = require("common/global/warehousesList");
var emptyCell_1 = require("portal/components/Grid/helpers/emptyCell");
var valueCell_1 = require("portal/components/Grid/helpers/valueCell");
var hasProjectAndWarehousePermissionWithNoMinMax_1 = require("portal/pages/Projects/hasProjectAndWarehousePermissionWithNoMinMax");
var getDateForCell_1 = __importDefault(require("portal/utils/getDateForCell"));
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var Grid_1 = require("../../../components/Grid/Grid");
var titleCell_1 = require("../../../components/Grid/helpers/titleCell");
var valueByMode_1 = require("../../../components/Grid/helpers/valueByMode");
var header_1 = require("../../../components/header");
var OrderHeader_1 = __importDefault(require("../components/OrderHeader"));
var IRGrid_1 = require("../IR/IRGrid");
function DNGridWarehouse(_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    var state = _a.state, mode = _a.mode, dispatch = _a.dispatch, DNId = _a.DNId;
    var hasSignature = (_b = projectsList_1.globalProjectsData[state.DNData.projectId].hasSignature) !== null && _b !== void 0 ? _b : false;
    var t = (0, react_i18next_1.useTranslation)().t;
    var warehouseName = (_d = (_c = warehousesList_1.globalWarehousesData[state.DNData.warehouseId]) === null || _c === void 0 ? void 0 : _c.name) !== null && _d !== void 0 ? _d : '';
    var DNBody = [
        [
            (0, titleCell_1.TitleCell)({ title: t('dn.deliveryNoteNumber'), colSpan: 2 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (_e = state.DNData.DNNumber) !== null && _e !== void 0 ? _e : '',
                inputType: 'text',
                path: 'DNData.DNNumber',
                colSpan: 5,
                required: state.triedSubmitting,
            }),
            (0, titleCell_1.TitleCell)({ title: t('dn.projectCode'), colSpan: 2 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: state.DNData.projectCode,
                inputType: 'text',
                colSpan: 3,
            }),
        ],
        [
            (0, titleCell_1.TitleCell)({ title: t('dn.deliveryNoteDate'), colSpan: 2 }),
            (_h = (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: mode === 'view'
                    ? t('common.date', { date: (0, getDateForCell_1.default)((_f = state === null || state === void 0 ? void 0 : state.DNData) === null || _f === void 0 ? void 0 : _f.deliveryDate, mode) })
                    : (0, getDateForCell_1.default)((_g = state === null || state === void 0 ? void 0 : state.DNData) === null || _g === void 0 ? void 0 : _g.deliveryDate, mode),
                inputType: 'datePicker',
                colSpan: 10,
                path: 'DNData.deliveryDate',
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
            })) !== null && _h !== void 0 ? _h : null,
        ],
        [
            (0, titleCell_1.TitleCell)({ title: t('dn.poNo'), colSpan: 2 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: state.DNData.PONumber,
                inputType: 'text',
                colSpan: 10,
            }),
        ],
        [
            (0, titleCell_1.TitleCell)({ title: t('dn.deliveryLocation'), colSpan: 2 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: warehouseName,
                inputType: 'text',
                colSpan: 10,
            }),
        ],
    ];
    var supplierSection = [
        [(0, titleCell_1.TitleCell)({ title: t('dn.supplierNameAndAddress'), colSpan: 6 }), (0, titleCell_1.TitleCell)({ title: t('dn.consigneeName'), colSpan: 6 })],
        [
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (_j = state.DNData.supplierName) !== null && _j !== void 0 ? _j : '',
                inputType: 'text',
                colSpan: 6,
            }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (_k = state.DNData.consigneeName) !== null && _k !== void 0 ? _k : '',
                inputType: 'text',
                colSpan: 6,
            }),
        ],
        [
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (_l = state.DNData.supplierAddress) !== null && _l !== void 0 ? _l : '',
                inputType: 'text',
                colSpan: 6,
            }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: state.DNData.deliveryLocation,
                inputType: 'textInput',
                colSpan: 6,
                path: 'DNData.deliveryLocation',
            }),
        ],
    ];
    var itemsHeader = [
        (0, titleCell_1.TitleCell)({ title: t('dn.itemNo') }),
        (0, titleCell_1.TitleCell)({ title: t('dn.budgetLine') }),
        (0, titleCell_1.TitleCell)({ title: t('dn.description'), colSpan: 2 }),
        (0, titleCell_1.TitleCell)({ title: t('dn.brandModel'), colSpan: 2 }),
        (0, titleCell_1.TitleCell)({ title: t('dn.unit') }),
        (0, titleCell_1.TitleCell)({ title: t('dn.quantityOrdered'), colSpan: 2 }),
        (0, titleCell_1.TitleCell)({ title: t('dn.quantityReceived'), colSpan: 2 }),
        (0, titleCell_1.TitleCell)({ title: t('dn.remarks'), colSpan: 1 }),
    ];
    var itemsBody = state.DNItems.map(function (itemDoc, idx) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        var unitName = (_b = (_a = unitsList_1.globalUnitsData[itemDoc === null || itemDoc === void 0 ? void 0 : itemDoc.unitId]) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '';
        var budgetLine = (_c = budgetLinesList_1.globalBudgetLinesData[itemDoc === null || itemDoc === void 0 ? void 0 : itemDoc.budgetLineId]) === null || _c === void 0 ? void 0 : _c.code;
        return [
            (0, valueByMode_1.ValueByMode)({ mode: 'view', value: idx + 1, inputType: 'text' }),
            (0, valueByMode_1.ValueByMode)({ mode: 'view', value: budgetLine, inputType: 'text' }),
            (0, valueByMode_1.ValueByMode)({
                mode: 'view',
                value: "".concat((_f = (_e = (_d = itemDoc === null || itemDoc === void 0 ? void 0 : itemDoc.orderedItem) === null || _d === void 0 ? void 0 : _d.name) !== null && _e !== void 0 ? _e : itemDoc === null || itemDoc === void 0 ? void 0 : itemDoc.productName) !== null && _f !== void 0 ? _f : '', "-").concat((_j = (_h = (_g = itemDoc === null || itemDoc === void 0 ? void 0 : itemDoc.orderedItem) === null || _g === void 0 ? void 0 : _g.description) !== null && _h !== void 0 ? _h : itemDoc === null || itemDoc === void 0 ? void 0 : itemDoc.productDescription) !== null && _j !== void 0 ? _j : ''),
                inputType: 'text',
                colSpan: 2,
            }),
            (0, valueByMode_1.ValueByMode)({
                mode: 'view',
                value: itemDoc === null || itemDoc === void 0 ? void 0 : itemDoc.offeredItem,
                inputType: 'text',
                colSpan: 2,
            }),
            (0, valueByMode_1.ValueByMode)({ mode: 'view', value: unitName !== null && unitName !== void 0 ? unitName : '', inputType: 'text' }),
            (0, valueByMode_1.ValueByMode)({ mode: mode, value: (_k = itemDoc === null || itemDoc === void 0 ? void 0 : itemDoc.orderedQuantity) !== null && _k !== void 0 ? _k : 0, inputType: 'text', colSpan: 2 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: itemDoc === null || itemDoc === void 0 ? void 0 : itemDoc.receivedQuantity,
                inputType: 'numberInput',
                path: "DNItems[".concat(idx, "].receivedQuantity"),
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
                colSpan: 2,
            }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (_l = itemDoc === null || itemDoc === void 0 ? void 0 : itemDoc.remarks) !== null && _l !== void 0 ? _l : '',
                inputType: 'textArea',
                colSpan: 1,
                path: "DNItems[".concat(idx, "].remarks"),
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
            }),
        ];
    });
    var approvalCell = function (approvalType, requiredApprovalType) {
        var _a, _b, _c, _d, _e, _f;
        var approval = (_a = state.approvalsData) === null || _a === void 0 ? void 0 : _a.find(function (e) {
            return e.approvalType === approvalType;
        });
        var supplierCurrency = (_b = currenciesList_1.globalCurrenciesData[state.RFQsData.currencyId]) === null || _b === void 0 ? void 0 : _b.name;
        // const overallTotalInDollar =
        //     supplierCurrency === 'Euro (€)'
        //         ? state.POsData.overallTotal * state.RFQsData.exchangeRate
        //         : state.POsData.overallTotal / state.RFQsData.exchangeRate
        var overallTotalRFQInDollar = supplierCurrency === 'Euro (€)'
            ? state.RFQsData.overallTotal * state.RFQsData.exchangeRate
            : state.RFQsData.overallTotal / state.RFQsData.exchangeRate;
        console.log({ overallTotalRFQInDollar: overallTotalRFQInDollar });
        var approvalPermissions = (0, hasProjectAndWarehousePermissionWithNoMinMax_1.hasProjectAndWarehousePermissionWithNoMinMax)((_c = state === null || state === void 0 ? void 0 : state.DNData) === null || _c === void 0 ? void 0 : _c.warehouseId, (_d = state === null || state === void 0 ? void 0 : state.DNData) === null || _d === void 0 ? void 0 : _d.projectId, ["DN".concat(approvalType, "Approval")], overallTotalRFQInDollar);
        var requiredApproval = (_e = state.approvalsData) === null || _e === void 0 ? void 0 : _e.find(function (e) {
            return e.approvalType === requiredApprovalType;
        });
        var commonConditions = state.DNData.status !== 'approved' &&
            state.DNData.status !== 'cancelled' &&
            state.DNData.status !== 'completed' &&
            state.DNData.status !== 'draft' &&
            state.DNData.status !== 'singedAndArchived';
        var isThereRequiredApproval = approvalType === 'receivedAndCheckedBy' ? true : requiredApproval;
        console.log({ approval: approval, approvalPermissions: approvalPermissions, commonConditions: commonConditions, isThereRequiredApproval: isThereRequiredApproval });
        if (approval) {
            return (0, valueByMode_1.ValueByMode)({
                mode: 'view',
                value: (_f = usersList_1.globalUsersData[approval.userId]) === null || _f === void 0 ? void 0 : _f.name,
                colSpan: 2,
                rowSpan: 2,
            });
        }
        else if (approvalPermissions && commonConditions && isThereRequiredApproval) {
            return {
                action: 'Approve',
                payload: approvalType,
                text: t('cba.approve'),
                confirmMessage: t('alerts.areYouSureYouWantToApproveThisDocument'),
                confirmAction: true,
                type: 'button',
                colSpan: 2,
                rowSpan: 2,
            };
        }
        else {
            console.log('empty');
            return (0, emptyCell_1.emptyCell)({
                colSpan: 2,
                rowSpan: 2,
            });
        }
    };
    function approvals(state) {
        var getApproval = function (approvalType) {
            var _a;
            var approval = (_a = state.approvalsData) === null || _a === void 0 ? void 0 : _a.find(function (e) {
                return e.approvalType === approvalType;
            });
            return approval;
        };
        var approvingDate = function (approvalType) {
            var approval2 = getApproval(approvalType);
            var date = approval2 === null || approval2 === void 0 ? void 0 : approval2.approvedAt;
            return t('common.date', { date: date === null || date === void 0 ? void 0 : date.toDate() });
        };
        var approvingSig = function (approvalType) {
            var approval2 = getApproval(approvalType);
            var sig = approval2 === null || approval2 === void 0 ? void 0 : approval2.signatureURL;
            return sig;
        };
        return [
            [
                (0, titleCell_1.TitleCell)({ title: t('dn.receivedAndCheckedBy'), colSpan: 6, rowSpan: 1 }),
                (0, titleCell_1.TitleCell)({ title: t('dn.approvedBy'), colSpan: 6, rowSpan: 1 }),
            ],
            [
                (0, titleCell_1.TitleCell)({ title: t('dn.name'), colSpan: 2, rowSpan: 1 }),
                (0, titleCell_1.TitleCell)({ title: t('dn.sign'), colSpan: 2, rowSpan: 1 }),
                (0, titleCell_1.TitleCell)({ title: t('dn.date'), colSpan: 2, rowSpan: 1 }),
                (0, titleCell_1.TitleCell)({ title: t('dn.name'), colSpan: 2, rowSpan: 1 }),
                (0, titleCell_1.TitleCell)({ title: t('dn.sign'), colSpan: 2, rowSpan: 1 }),
                (0, titleCell_1.TitleCell)({ title: t('dn.date'), colSpan: 2, rowSpan: 1 }),
            ],
            [
                approvalCell('receivedAndCheckedBy'),
                (0, valueCell_1.ValueCell)({ value: ' ', img: hasSignature && approvingSig('receivedAndCheckedBy'), colSpan: 2, rowSpan: 2 }),
                (0, valueCell_1.ValueCell)({ value: approvingDate('receivedAndCheckedBy'), colSpan: 2, rowSpan: 2 }),
                approvalCell('approvedBy', 'receivedAndCheckedBy'),
                (0, valueCell_1.ValueCell)({ value: ' ', img: hasSignature && approvingSig('approvedBy'), colSpan: 2, rowSpan: 2 }),
                (0, valueCell_1.ValueCell)({ value: approvingDate('approvedBy'), colSpan: 2, rowSpan: 2 }),
            ],
            [],
        ];
    }
    var footer = [
        [(0, titleCell_1.TitleCell)({ title: t('dn.deliveredBy'), colSpan: 12 })],
        [(0, titleCell_1.TitleCell)({ title: t('dn.dateNameTitleAndSignature'), colSpan: 12 })],
        [(0, emptyCell_1.emptyCell)({ colSpan: 12, rowSpan: 2 })],
        [],
    ];
    var donorId = (_m = projectsList_1.globalProjectsData[state.DNData.projectId]) === null || _m === void 0 ? void 0 : _m.donorId;
    var miLogo = __assign(__assign({}, header_1.baseCell), { type: 'image', src: (_o = donorsList_1.globalDonorsData[donorId]) === null || _o === void 0 ? void 0 : _o.logo, height: 50, colSpan: 4, textAlign: 'center' });
    var gridData = {
        data: __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([
            (0, IRGrid_1.logoHeader)({ projectId: state.DNData.projectId, idaLogo: miLogo, title: t('dn.deliveryNoteDn'), colSpan: 4 })
        ], DNBody, true), supplierSection, true), [
            itemsHeader
        ], false), itemsBody, true), approvals(state), true), footer, true),
    };
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(OrderHeader_1.default, { state: __assign({}, state.DNData), dispatch: dispatch, type: "DN", orderRef: collectionsRef_1.DNsRef.doc(DNId) }), (0, jsx_runtime_1.jsx)("div", __assign({ style: { backgroundColor: '#fff' } }, { children: (0, jsx_runtime_1.jsx)(Grid_1.ExcelLikeGrid, { onButtonClicked: function (action, payload) {
                        dispatch({
                            type: 'buttonClick',
                            data: {
                                action: action,
                                payload: payload,
                            },
                        });
                    }, onValueUpdate: function (path, newValue) {
                        dispatch({
                            type: 'update',
                            payload: {
                                path: path,
                                newValue: newValue,
                            },
                        });
                    }, grid: gridData }) }))] }));
}
exports.DNGridWarehouse = DNGridWarehouse;
